import TagManager from 'react-gtm-module';

class TagManagerUtils {
  init = gtmId => {
    TagManager.initialize({ gtmId });
  } 

  pageView = (page, { ...optionalData }, even) => {
    if(even==='vpv-privado'){
      TagManager.dataLayer({
        dataLayer: {
          event: even,
          page
        }
      });
    }else{
      TagManager.dataLayer({
        dataLayer: {
          event: even,
          page,
          ...optionalData
        }
      });
    }
    
  }

  modalView = modalName => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'modal',
        modal: modalName
      }
    });
  }

  intEvent = ({ ...params }) => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'int',
        ...params
      }
    });
  }

  errorEvent = errorMessage => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'error',
        error: errorMessage
      }
    });
  }

  // TAGS ADICIONALES EN EL FLUJO FORMALIZACION CON FIRMA DIGITAL
  eventoClick = (url, accion) => {
    TagManager.dataLayer({
      dataLayer: {
        'event': 'eve',
        'eve-acc' : 'Click',
        'eve-cat' : url,
        'eve-lab' : accion
      }
    });
  }

  actualizacionDeCorreo = (url, condicion, tipoFirma) => {
    TagManager.dataLayer({
      dataLayer: {
        'event': 'vpv-privado',
        'page' : url,
        'mailRespaldo' : condicion,
        'producto': tipoFirma

      }
    });
  }


  // ACC GENERAL
  globalTag = (marca) => {
    TagManager.dataLayer({
      dataLayer: marca
    });
  }

  


}

export default new TagManagerUtils();
